import EditExam from './EditExam';

export default EditExam;
